import { useEffect } from 'react';
import { scheduleModalLockRelease } from '../utils/modalCleanup';

export default function useModalCleanup(isModalOpen) {
    useEffect(() => {
        if (!isModalOpen) {
            scheduleModalLockRelease(350);
        }
    }, [isModalOpen]);
}
